
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagementBaseUrl, userManagement } from "../endpoints";

export const accountCategoryService = createApi({
  reducerPath: "accountCategoryMasterService",
  baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
  tagTypes: ["accountCategoryMaster"],
  endpoints: (builder) => ({
    getAllAccountCategoryWithPagination: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.accountCategoryMasterController.getAllAccountCategoryWithPagination}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
          method: "GET",
          headers: { Authorization: `Bearer ${body.token}`},
          // body: body.payload,
        };
      },
    }),
    getAllAccountCategoryWithSearch: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.accountCategoryMasterController.getAllAccountCategoryWithSearch}`,
          method: "POST",
          headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
    updateAccountCategory: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.accountCategoryMasterController.updateAccountCategory}/${body.id}`,
          method: "PUT",
          headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
    deleteAccountCategoryById: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.accountCategoryMasterController.deleteAccountCategoryById}/${body.id}`,
          method: "DELETE",
          headers: { Authorization: `Bearer ${body.token}`},
        };
      },
    }),
    getAccountCategoryById: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.accountCategoryMasterController.getAccountCategoryById}/${body.id}`,
          method: "GET",
          headers: { Authorization: `Bearer ${body.token}`},
        };
      },
    }),
    saveAccountCategory: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.accountCategoryMasterController.saveAccountCategory}`,
          method: "POST",
          headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
    getAllAccountCategory: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.accountCategoryMasterController.getAllAccountCategory}`,
          method: "GET",
          headers: { Authorization: `Bearer ${body.token}`},
        };
      },
    }),
    bulkSaveAccountCategory: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.accountCategoryMasterController.bulkSaveAccountCategory}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        }
      }
    }),
  }),
});
export const {
  useSaveAccountCategoryMutation,
  useUpdateAccountCategoryMutation,
  useBulkSaveAccountCategoryMutation,
  useDeleteAccountCategoryByIdMutation,
  useGetAccountCategoryByIdMutation,
  useGetAllAccountCategoryMutation,
  useGetAllAccountCategoryWithPaginationMutation,
  useGetAllAccountCategoryWithSearchMutation
} = accountCategoryService;
